import { getMyEmployerVehicleSettlementSurveyResponseChartData } from "../../../../api/dossier/getMyEmployerVehicleSettlementSurveyResponseChartData";
import APChart from "../APChart";

const ratingSliceLabels = {
  excellent: "Excellent",
  good: "Good",
  ok: "Ok",
  poor: "Poor",
  terrible: "Terrible",
};

const EmployerVehicleSettlementSurveyResponsesChart = () => {
  return (
    <APChart
      type="pie"
      getData={() => getMyEmployerVehicleSettlementSurveyResponseChartData()}
      dimensions={[
        { key: "value", label: "Value", sliceLabels: ratingSliceLabels },
        {
          key: "experience",
          label: "Experience",
          sliceLabels: ratingSliceLabels,
        },
        { key: "overall", label: "Overall", sliceLabels: ratingSliceLabels },
        {
          key: "recommend",
          label: "Recommendation",
          sliceLabels: { yes: "Yes", no: "No" },
        },
      ]}
      valueOptions={{ type: "count" }}
    />
  );
};

export default EmployerVehicleSettlementSurveyResponsesChart;
